import { render, staticRenderFns } from "./event-template.vue?vue&type=template&id=46fc90b2&scoped=true&"
import script from "./event-template.vue?vue&type=script&lang=js&"
export * from "./event-template.vue?vue&type=script&lang=js&"
import style0 from "./event-template.vue?vue&type=style&index=0&id=46fc90b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fc90b2",
  null
  
)

export default component.exports